import React from 'react'

const Footer = () => {
    return (
        <footer>
            <div>

                Made by Ida Näslund on Technigo Bootcamp, spring -22
            </div>
        </footer>
    )
}

export default Footer